
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import useSWR from "swr";
import { API_URL } from "../../config";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useMobile from "customHooks/useMobile";
import { useRouter } from "next/router";
import CustomContentLoader from "../../components/ReuseableCompos/CustomContentLoader";
import TransparencyDonationCards from "../../components/Transparency/TransparencyDonationCards";
import useUtilities from "../../customHooks/useUtilities";
import TransparencyLayout from "../../layout/TransparencyLayout";
const Transparency = () => {
    const { t } = useTranslation("common");
    const { data, error, isLoading } = useSWR(`${API_URL}/transparency/donations`, {
        revalidateOnFocus: false,
        // revalidateOnMount: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false
    });
    const { data: utilities } = useUtilities();
    const isMobile = useMobile("md");
    const { locale } = useRouter();
    const desc = (num: number) => utilities?.transparency_intro?.[locale]
        ?.split("<p>")?.[num]?.split("</p>")?.[0]
        ?.replace("&nbsp;", " ");
    const Skeleton = () => {
        return (<CustomContentLoader viewBox={`0 0 ${isMobile ? "400" : "1200"} 94`}>
        <rect x="0" y="0" rx="7" ry="7" width={isMobile ? "400" : "1200"} height="26"/>
        <rect x={isMobile ? "100" : "400"} y="40" rx="7" ry="7" width={isMobile ? "200" : "400"} height="26"/>
      </CustomContentLoader>);
    };
    return (<>
      {/* SEO in Layout */}

      <div className="d-flex flex-column h-100">
        <div className="pt-2 pt-md-4 container px-3 px-md-0">
          {utilities
            ? [0, 0, 0].map((_, i) => {
                return (<p key={i} className="text-center fs-18 fw-medium mb-3" style={{
                        lineHeight: 2
                    }}>
                    {desc(i + 1)}
                  </p>);
            })
            : [0, 0, 0].map((_, i) => {
                if (isMobile) {
                    return (<div className="mb-3" key={i}>
                      {[0, 0].map((_, i) => {
                            return (<div className="" key={i}>
                            <Skeleton key={i}/>
                          </div>);
                        })}
                    </div>);
                }
                return <Skeleton key={i}/>;
            })}
          <TransparencyDonationCards isLoading={isLoading} data={data} error={error} rec spent/>
          <div className="d-flex justify-content-center">
            <MolhamButton id="transparency-donations-btn" endIcon="fe-arrow-right" label={t(`donations_record`)} hrefClassName="w-100" className={`w-100`} href={`transparency/donations/${new Date()
            .toISOString()
            .split("T")[0]
            .replaceAll("-", "")}`}/>
          </div>
        </div>
      </div>
    </>);
};
export default Transparency;
Transparency.Layout = TransparencyLayout;

    async function __Next_Translate__getStaticProps__1a13f66bead__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/transparency/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bead__ as getStaticProps }
  